import React from 'react';
import { Box, Chip, Tooltip, Typography } from '@material-ui/core';

export const getWarehouseName = (id, warehouses) => {
  const wh = warehouses.find((w) => w.warehouse_id === id);
  return wh ? (wh.warehouse_name || wh.warehouse_id) : id;
};

export const getCountryName = (code, countries) => {
  const c = countries.find((ct) => ct.code === code);
  return c ? c.name : code;
};

export const renderChipList = (items, maxShow = 3) => {
  if (!items || items.length === 0) {
    return <Typography style={{ fontSize: '12px', color: '#999' }}>—</Typography>;
  }
  const visible = items.slice(0, maxShow);
  const remaining = items.length - maxShow;
  return (
    <Box style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
      {visible.map((val) => (
        <Chip key={val} label={val} size="small" style={{ fontSize: '11px', height: 22 }} />
      ))}
      {remaining > 0 && (
        <Tooltip title={items.slice(maxShow).join(', ')}>
          <Chip label={`+${remaining}`} size="small" style={{ fontSize: '11px', height: 22 }} variant="outlined" />
        </Tooltip>
      )}
    </Box>
  );
};

export const downloadCsvTemplate = () => {
  const csvContent = 'option_id\nOPTION_001\nOPTION_002\n';
  const blob = new Blob([csvContent], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.setAttribute('href', url);
  a.setAttribute('download', 'option_ids_template.csv');
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

export const RULES_PER_PAGE = 5;

/** Coerce API fields that may be a single scalar into a non-empty array for list UIs. */
const asIdArray = (v) => {
  if (v == null || v === '') return [];
  return Array.isArray(v) ? v : [v];
};

/** Normalize API SlaRule (snake_case) for table display */
export const normalizeSlaRule = (r) => {
  if (!r) return {};
  return {
    _id: r._id || r.id,
    rule_name: r.rule_name ?? '',
    last_mile_warehouse: r.last_mile_warehouse ?? r.warehouse ?? '',
    destination_countries: asIdArray(r.destination_countries ?? r.countries),
    destination_cities: asIdArray(r.destination_cities ?? r.cities),
    category_ids: asIdArray(r.category_ids ?? r.categoryIds),
    sold_by: asIdArray(r.sold_by ?? r.soldBy),
    seller_ids: asIdArray(r.seller_ids ?? r.sellerId),
    brand_names: asIdArray(r.brand_names ?? r.brandName),
    additional_sla: r.additional_sla ?? r.additionalSlaDays ?? 0,
    priority: r.priority ?? 0,
    status: r.status !== false,
    created_at: r.created_at,
    updated_at: r.updated_at,
  };
};

export const normalizeOptionOverride = (o) => {
  if (!o) return {};
  const option_ids = o.option_ids ?? o.optionIds ?? (o.option_id != null && o.option_id !== '' ? [String(o.option_id)] : []);
  const destination_countries =
    o.destination_countries ?? o.countries ?? (o.destination_country != null && o.destination_country !== '' ? [String(o.destination_country)] : []);
  return {
    _id: o._id || o.id,
    last_mile_warehouse: o.last_mile_warehouse ?? o.warehouse ?? '',
    destination_countries,
    option_ids,
    option_id: o.option_id != null ? String(o.option_id) : (option_ids[0] || ''),
    destination_country: o.destination_country != null ? String(o.destination_country) : (destination_countries[0] || ''),
    additional_sla: o.additional_sla ?? o.additionalSlaDays ?? 0,
    status: o.status !== false,
    created_at: o.created_at,
    updated_at: o.updated_at,
  };
};
